import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { OpenIdConfiguration } from 'angular-auth-oidc-client';
import { Observable, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LogoutIntegrationService {
    private readonly httpClient = inject(HttpClient);

    // https://github.com/damienbod/angular-auth-oidc-client/issues/1514
    // https://cwiki.mobicorp.ch/confluence/display/JFK/Implementation+guide+for+OAuth+clients#ImplementationguideforOAuthclients-claims
    public revokeRefreshToken(config: OpenIdConfiguration, refreshToken: string): Observable<void> {
        if (!config.authWellknownEndpoints?.revocationEndpoint) {
            return throwError(() => new Error('Configuration not found'));
        }
        let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        if (config.clientId) {
            headers = headers.append('Authorization', `Basic ${btoa(config.clientId.concat(':'))}`);
        }

        const body = new URLSearchParams();
        body.set('token', refreshToken);
        body.set('token_type_hint', 'refresh_token');
        return this.httpClient.post<void>(
            `${config.authWellknownEndpoints.revocationEndpoint}`,
            body,
            {
                headers,
            },
        );
    }
}
